var _path, _path2, _path3, _path4, _path5, _path6, _rect, _rect2, _rect3, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSubheaderManagedServices(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 56,
    viewBox: "0 0 57 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 4H26.5V2H22.5V4ZM22.5 4.33333V4H20.5V4.33333H22.5ZM19.5 6.33333H20.5V4.33333H19.5V6.33333ZM19.5 9V6.33333H17.5V9H19.5ZM29.5 9H19.5V11H29.5V9ZM29.5 6.33333V9H31.5V6.33333H29.5ZM28.5 6.33333H29.5V4.33333H28.5V6.33333ZM26.5 4V4.33333H28.5V4H26.5ZM28.5 4.33333V4.33333H26.5C26.5 5.4379 27.3954 6.33333 28.5 6.33333V4.33333ZM31.5 6.33333C31.5 5.22876 30.6046 4.33333 29.5 4.33333V6.33333H31.5ZM29.5 11C30.6046 11 31.5 10.1046 31.5 9H29.5V9V11ZM17.5 9C17.5 10.1046 18.3954 11 19.5 11V9H19.5H17.5ZM19.5 4.33333C18.3954 4.33333 17.5 5.22876 17.5 6.33333H19.5V6.33333V4.33333ZM20.5 4.33333V4.33333V6.33333C21.6046 6.33333 22.5 5.4379 22.5 4.33333H20.5ZM26.5 4V4H28.5C28.5 2.89543 27.6046 2 26.5 2V4ZM22.5 2C21.3954 2 20.5 2.89543 20.5 4H22.5V4V2Z",
    fill: "#4F7FA7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 18L16.8333 20C17.8747 18.4379 18.4586 17.5621 19.5 16",
    stroke: "#4F7FA7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 30L16.8333 32C17.8747 30.4379 18.4586 29.5621 19.5 28",
    stroke: "#4F7FA7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 42L16.8333 44C17.8747 42.4379 18.4586 41.5621 19.5 40",
    stroke: "#4F7FA7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 6H38.5C40.7091 6 42.5 7.79086 42.5 10V19M18.5 6H10.5C8.29086 6 6.5 7.79086 6.5 10V49C6.5 51.2091 8.29086 53 10.5 53H38.5C40.7091 53 42.5 51.2091 42.5 49V37.5",
    stroke: "#4F7FA7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5 20.5V11C38.5 10.4477 38.0523 10 37.5 10H11.5C10.9477 10 10.5 10.4477 10.5 11V48C10.5 48.5523 10.9477 49 11.5 49H37.5C38.0523 49 38.5 48.5523 38.5 48V37.5",
    stroke: "#4F7FA7",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13.5,
    y: 14,
    width: 8,
    height: 8,
    rx: 1,
    stroke: "#4F7FA7",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13.5,
    y: 26,
    width: 8,
    height: 8,
    rx: 1,
    stroke: "#4F7FA7",
    strokeWidth: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 13.5,
    y: 38,
    width: 8,
    height: 8,
    rx: 1,
    stroke: "#4F7FA7",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 16L34.5 16",
    stroke: "#4F7FA7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 28H30.5",
    stroke: "#4F7FA7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 20H29.5",
    stroke: "#4F7FA7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 32H29.5",
    stroke: "#4F7FA7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 40H34.5",
    stroke: "#4F7FA7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 44H29.5",
    stroke: "#4F7FA7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5 27.5237V30.4763C50.5 30.7661 50.2443 30.9877 49.9579 30.9468L49.2692 30.8513C49.0271 30.8173 48.8055 30.9741 48.7407 31.2093C48.5464 31.939 48.2566 32.6277 47.8883 33.2653C47.7656 33.4766 47.8133 33.746 48.0077 33.8926L48.5634 34.312C48.7953 34.4859 48.8191 34.8234 48.6146 35.028L46.528 37.1146C46.3234 37.3157 45.9859 37.2953 45.812 37.0634L45.3926 36.5077C45.246 36.3133 44.9766 36.2656 44.7653 36.3883C44.1277 36.7566 43.439 37.0464 42.7093 37.2407C42.4741 37.3055 42.3173 37.5271 42.3513 37.7692L42.4468 38.4579C42.4877 38.7443 42.2661 39 41.9763 39H39.0237C38.7339 39 38.5123 38.7443 38.5532 38.4579L38.6487 37.7692C38.6827 37.5271 38.5259 37.3055 38.2907 37.2407C37.561 37.0464 36.8723 36.7566 36.2347 36.3883C36.0234 36.2656 35.754 36.3133 35.6074 36.5077L35.188 37.0634C35.0141 37.2953 34.6766 37.3191 34.472 37.1146L32.3854 35.028C32.1843 34.8234 32.2047 34.4859 32.4366 34.312L32.9923 33.8926C33.1867 33.746 33.2344 33.4766 33.1117 33.2653C32.7434 32.6277 32.4536 31.939 32.2593 31.2093C32.1945 30.9741 31.9729 30.8173 31.7308 30.8513L31.0421 30.9468C30.7557 30.9877 30.5 30.7661 30.5 30.4763V27.5237C30.5 27.2339 30.7557 27.0123 31.0421 27.0532L31.7308 27.1487C31.9729 27.1827 32.1945 27.0259 32.2593 26.7907C32.4536 26.061 32.7434 25.3723 33.1117 24.7347C33.2344 24.5234 33.1867 24.254 32.9923 24.1074L32.4366 23.688C32.2047 23.5141 32.1809 23.1766 32.3854 22.972L34.472 20.8854C34.6766 20.6843 35.0141 20.7047 35.188 20.9366L35.6074 21.4923C35.754 21.6867 36.0234 21.7344 36.2347 21.6117C36.8723 21.2434 37.561 20.9536 38.2907 20.7593C38.5259 20.6945 38.6827 20.4729 38.6487 20.2308L38.5532 19.5421C38.5123 19.2557 38.7339 19 39.0237 19H41.9763C42.2661 19 42.4877 19.2557 42.4468 19.5421L42.3513 20.2308C42.3173 20.4729 42.4741 20.6945 42.7093 20.7593C43.439 20.9536 44.1277 21.2434 44.7653 21.6117C44.9766 21.7344 45.246 21.6867 45.3926 21.4923L45.812 20.9366C45.9859 20.7047 46.3234 20.6809 46.528 20.8854L48.6146 22.972C48.8157 23.1766 48.7953 23.5141 48.5634 23.688L48.0077 24.1074C47.8133 24.254 47.7656 24.5234 47.8883 24.7347C48.2566 25.3723 48.5464 26.061 48.7407 26.7907C48.8055 27.0259 49.0271 27.1827 49.2692 27.1487L49.9579 27.0532C50.2443 27.0123 50.5 27.2339 50.5 27.5237Z",
    stroke: "#4F7FA7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40.5,
    cy: 29,
    r: 4,
    stroke: "#4F7FA7",
    strokeWidth: 2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubheaderManagedServices);
export default __webpack_public_path__ + "static/media/subheader-managed-services.e060b172c98a8d5d992e80f799a8f201.svg";
export { ForwardRef as ReactComponent };